import React, { useEffect, useState } from "react";
import { useIsMounted } from "../../hooks/useIsMounted";
import { casesService } from "../../services";
import { CaseAllocation } from "./CaseAllocation";
import { DashboardSettings } from "./DashboardSettings";
import { RefreshButton } from "./RefreshButton";
export const DashboardAppBar = ({ navigate, params }) => {
    const [dashboards, setDashboards] = useState(undefined);
    const isMountedRef = useIsMounted();
    useEffect(() => {
        casesService.getAnalyticsDashboards().then(response => {
            const dashboards = response;
            if (isMountedRef.current) {
                setDashboards(dashboards);
            }
        });
    }, [isMountedRef]);
    return (React.createElement(React.Fragment, null,
        dashboards && dashboards.length > 1 ? (React.createElement(DashboardSettings, { navigate: navigate, params: params, dashboards: dashboards })) : null,
        "\u00A0",
        React.createElement(RefreshButton, null),
        "\u00A0",
        React.createElement(CaseAllocation, null),
        "\u00A0"));
};
